import { render, staticRenderFns } from "./biddingRemarkAdd.vue?vue&type=template&id=2225d5cf&scoped=true&"
import script from "./biddingRemarkAdd.vue?vue&type=script&lang=js&"
export * from "./biddingRemarkAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2225d5cf",
  null
  
)

export default component.exports